module.exports = __webpack_public_path__ + "static/media/weather-logo.f6792e41.png";